import imgSrc from "bgImages/tramites.JPG";
import PageTitle from "componets/molecules/PageTitle/pageTitle";
import MenuInOrbit from "componets/organisms/menuInOrbit/menuInOrbit";
import { useEffect, useState } from "react";
import "./aboutUsTemplate.scss";

import AboutUsContent from "componets/organisms/aboutUsContent/aboutUsContent";
import PersonalFooter from "componets/organisms/personalFooter/personalFooter";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
const AboutUsTemplate = ({ data, menuOptions }) => {
  const [currentURL, setCurrentURL] = useState(useParams()["*"]);
  const navigate = useNavigate();
  useEffect(() => {
    var proveExistence1 = menuOptions.categories[0].options.find((val) => {
      return val.value === currentURL;
    });
    var proveExistence2 = menuOptions.categories[1].options.find((val) => {
      return val.value === currentURL;
    });
    var proveExistence = proveExistence1 || proveExistence2;
    if (proveExistence !== undefined) {
      setDisplayedContent(currentURL);
    } else {
      navigate(`/acercade/sobreNosotros`);
    }
  }, [currentURL]);

  const [displayedContent, setDisplayedContent] = useState("sobreNosotros");
  const [displayedText, setDisplayedText] = useState("Sobre nosotros");
  useEffect(() => {
    var proveExistence1 = menuOptions.categories[0].options.find((val) => {
      return val.value === displayedContent;
    });
    var proveExistence2 = menuOptions.categories[1].options.find((val) => {
      return val.value === displayedContent;
    });
    var proveExistence = proveExistence1 ? proveExistence1 : proveExistence2;
    if (proveExistence !== undefined) {
      setDisplayedText(proveExistence.name);
    } else {
      setDisplayedContent("sobreNosotros");
      setDisplayedText("Sobre nosotros");
    }
  }, [displayedContent]);
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Acerca de", link: "/acercade/sobreNosotros" },
    { text: displayedText, link: `/acercade/${displayedContent}` },
  ];
  return (
    <>
      <PageTitle
        breadData={breadcrumsData}
        type="right"
        imgSrc={imgSrc}
        data={{ title: "Conoce la sede la paz" }}
      />
      <div className="about-content__container">
        <Routes>
          <Route
            path=":type"
            element={
              <>
                <MenuInOrbit
                  selectedOption={displayedContent}
                  setOption={setDisplayedContent}
                  options={menuOptions}
                />
                {displayedContent === "sobreNosotros" && (
                  <AboutUsContent
                    data={data.sobreNosotros}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "galeria" && (
                  <AboutUsContent data={data.galeria} type={displayedContent} />
                )}
                {displayedContent === "misionVision" && (
                  <AboutUsContent
                    data={data.misionVision}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "historia" && (
                  <AboutUsContent
                    data={data.historia}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "directorio" && (
                  <AboutUsContent
                    data={data.directorio}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "mapaSede" && (
                  <AboutUsContent
                    data={data.mapaSede}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "direccionSede" && (
                  <AboutUsContent
                    data={data.direccionSede}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "docentes" && (
                  <AboutUsContent
                    data={data.docentes}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "planeacion" && (
                  <AboutUsContent
                    data={data.planeacion}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "relacionesI" && (
                  <AboutUsContent
                    data={data.relacionesI}
                    type={displayedContent}
                  />
                )}
                {displayedContent === "secretariaSede" && (
                  <AboutUsContent
                    data={data.secretariaSede}
                    type={displayedContent}
                  />
                )}
              </>
            }
          />
        </Routes>
      </div>
      <PersonalFooter textSize={1} />
    </>
  );
};

export default AboutUsTemplate;
